import { ref } from 'vue'
import { defineStore } from 'pinia'
import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock'
import HTMLUtill from '@/utilities/html'

export const useScreenLockStore = defineStore('screenLock', () => {
  const isLock = ref(false)
  const isBlackOut = ref(false)
  const isBlur = ref(false)
  const showWaitAnimation = ref(false)

  const lockScreen = (option: screenLockOption = {
    hasBlackOut: true,
    hasBlur: true,
    hasWaitAnimation: false,
    hasScrollLock: true,
  }, handleTargetElement: HTMLElement | null = null) => {
    isLock.value = true
    isBlackOut.value = !!option.hasBlackOut
    isBlur.value = !!option.hasBlur
    showWaitAnimation.value = !!option.hasWaitAnimation

    if (option.hasScrollLock) {
      if (handleTargetElement && HTMLUtill.isElement(handleTargetElement)) {
        disableBodyScroll(handleTargetElement)
      } else {
        const body = document.body
        disableBodyScroll(body)
      }
    }

  }

  const unlockScreen = () => {
    isLock.value = false
    isBlackOut.value = false
    isBlur.value = false
    showWaitAnimation.value = false
    clearAllBodyScrollLocks()
  }

  return {
    isLock,
    isBlackOut,
    isBlur,
    showWaitAnimation,
    lockScreen,
    unlockScreen,
  }
})
